import type { VideoObject, WithContext } from 'schema-dts';
import type { Video } from '../../hydration/WPVideo/types';

function getVideoSchema(video: Video): WithContext<VideoObject> {
  const {
    youtubeVideo: { contentDetails, player, snippet },
  } = video;
  const { thumbnails, description, title, publishedAt } = snippet;

  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: title,
    description,
    ...(thumbnails && {
      thumbnailUrl: [
        thumbnails.standard.url,
        thumbnails.default.url,
        thumbnails.high.url,
        thumbnails.medium.url,
        thumbnails.maxres.url,
      ],
    }),
    uploadDate: publishedAt,
    ...(contentDetails?.duration && { duration: contentDetails.duration }),
    ...(player?.embedHtml && { embedUrl: player.embedHtml }),
  };
}

export function VideoLinkedData({ video, id }: { video: Video; id: string }) {
  if (!video || !video.youtubeVideo) return null;

  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getVideoSchema(video)) }}
      key={id}
    />
  );
}
